export const exampleData = () => {
  return {
    sessions: {
      request: {
        begin: '2019-06-10',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 3123, date: '2019-06-10'},
          {count: 3772, date: '2019-06-17'},
          {count: 3852, date: '2019-06-24'},
          {count: 4045, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-06-10',
          untilTime: '2019-07-01',
          avgNewCount: 3698,
          totalCount: 14792,
        },
        data: [
          {count: 3123, date: '2019-06-10'},
          {count: 3772, date: '2019-06-17'},
          {count: 3852, date: '2019-06-24'},
          {count: 4045, date: '2019-07-01'},
        ],
        results: [
          {
            total: 14792,
            skuType: 'ALL',
            data: [
              {count: 3123, date: '2019-06-10'},
              {count: 3772, date: '2019-06-17'},
              {count: 3852, date: '2019-06-24'},
              {count: 4045, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    impressions: {
      request: {
        begin: '2019-06-10',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 2552, date: '2019-06-10'},
          {count: 2715, date: '2019-06-17'},
          {count: 2888, date: '2019-06-24'},
          {count: 3124, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-06-10',
          untilTime: '2019-07-01',
          avgNewCount: 2820,
          totalCount: 11279,
        },
        data: [
          {count: 2552, date: '2019-06-10'},
          {count: 2715, date: '2019-06-17'},
          {count: 2888, date: '2019-06-24'},
          {count: 3124, date: '2019-07-01'},
        ],
        results: [
          {
            total: 11279,
            skuType: 'ALL',
            data: [
              {count: 2552, date: '2019-06-10'},
              {count: 2715, date: '2019-06-17'},
              {count: 2888, date: '2019-06-24'},
              {count: 3124, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
    tryouts: {
      request: {
        begin: '2019-06-10',
        end: '2019-07-01',
        granularity: 'week',
      },
      response: {
        valid: [
          {count: 104855, date: '2019-06-10'},
          {count: 113892, date: '2019-06-17'},
          {count: 121824, date: '2019-06-24'},
          {count: 139372, date: '2019-07-01'},
        ],
        overall: {
          sinceTime: '2019-06-10',
          untilTime: '2019-07-01',
          avgNewCount: 1211,
          totalCount: 6055,
        },
        data: [
          {count: 104855, date: '2019-06-10'},
          {count: 113892, date: '2019-06-17'},
          {count: 121824, date: '2019-06-24'},
          {count: 139372, date: '2019-07-01'},
        ],
        results: [
          {
            total: 6055,
            skuType: 'ALL',
            data: [
              {count: 104855, date: '2019-06-10'},
              {count: 113892, date: '2019-06-17'},
              {count: 121824, date: '2019-06-24'},
              {count: 139372, date: '2019-07-01'},
            ],
          },
        ],
      },
    },
  };
};
